import { useQuery } from '@apollo/client';

import { AuthCurrentUserDocument, AuthCurrentUserQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import { LicenseType } from '@entities/billing';

import { useAcceptanceCredsMismatchWatcher } from './useAcceptanceCredsMismatchWatcher';
import { useAcceptanceAdvancedStatusNotifications } from './useAcceptanceAdvancedStatusNotifications';
import { useSbbolIntegrationReturnListener } from './useSbbolIntegrationReturnListener';

interface UseSberBusinessOnlineProps {
  licensesCount: number;
  hasTrialLicenses: boolean;
  hasInactiveLicenses: boolean;
  hasActiveLicenses: boolean;
  nonRenewableLicenses: LicenseType[];
  unpaidLicenses: LicenseType[];
}

interface UseSberBusinessOnline {
  sberAuthButtonVisible: boolean;
}

const useSberBusinessOnline = ({
  licensesCount,
  hasTrialLicenses,
  hasInactiveLicenses,
  hasActiveLicenses,
  nonRenewableLicenses,
  unpaidLicenses,
}: UseSberBusinessOnlineProps): UseSberBusinessOnline => {
  const { data: userData } = useQuery<AuthCurrentUserQuery>(AuthCurrentUserDocument, {
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  useAcceptanceCredsMismatchWatcher();

  useAcceptanceAdvancedStatusNotifications({
    licensesCount,
    hasTrialLicenses,
    hasInactiveLicenses,
    hasActiveLicenses,
    nonRenewableLicenses,
    unpaidLicenses,
  });

  useSbbolIntegrationReturnListener();

  const sberAuthButtonVisible = Boolean(userData?.currentUserPureQuery?.mainCompany?.sberIdButtonState?.isVisible);

  return { sberAuthButtonVisible };
};

export default useSberBusinessOnline;
